<template>
  <v-container>
    <manage-user
      v-if="choosenDeviceType!=null && path=='manageUser'"
      :choosenDeviceType="choosenDeviceType"
      @back="backinfo"
    ></manage-user>
    <info-devType
      v-if="choosenDeviceType!=null && path=='info'"
      :choosenDeviceType="choosenDeviceType"
      @back="back"
      @edit="editDeviceType"
      @error="error"
      @saved="saved"
      @user="editUserInDeviceType"
      @clickmarker="clickmarker"
      @dataAndAlert="manageDataAndAlert"
      @addMqtt="createMqtt"
      @updateMqtt="updateMqtt"
    ></info-devType>
    <edit-devType
      v-if="(path=='edit')"
      :choosenDeviceType="choosenDeviceType"
      :path="path"
      @backinfo="backinfo"
      @error="error"
      @saved="saved"
    ></edit-devType>
    <managealert
      v-if="(path=='manageDataAndAlert')"
      :choosenDeviceType="choosenDeviceType"
      :path="path"
      @updateAlert="updateAlert"
      @createAlert="createAlert"
      @back="backinfo"
    ></managealert>
    <setMqtt
      v-if="(path=='createMqtt') || (path=='updateMqtt')"
      :choosenDeviceType="choosenDeviceType"
      :deviceTypeMqtt="deviceTypeMqtt"
      :path="path"
      @saved="mqttSaved"
      @back="backinfo"
    ></setMqtt>
    <setalert
      v-if="(path=='createAlert') || (path=='updateAlert')"
      :choosenDeviceType="choosenDeviceType"
      :deviceTypeAlert="deviceTypeAlert"
      :path="path"
      @saved="alertSaved"
      @back="backManage"
    ></setalert>
    <create-devType v-if="(path=='create')" :path="path" @back="back" @error="error" @saved="saved"></create-devType>
    <v-row v-if="path==''">
      <v-col class="text-center">
        <v-btn class="ma-2" tile outlined color="primary" @click="createDeviceType">
          <v-icon left>mdi-plus-circle</v-icon>
          {{$t('DeviceTypes.create')}}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CreateDeviceTypeComponent from "../DeviceTypes/CreateDeviceType";
import DeviceTypeInfoComponent from "../DeviceTypes/DeviceTypeInfo";
import EditDeviceTypeComponent from "../DeviceTypes/EditDeviceType";
import ManageUserInDeviceTypeComponent from "../DeviceTypes/ManageUserInDeviceType";
import ManageAlertComponent from "../DeviceTypes/ManageAlert";
import SetAlertComponent from "../DeviceTypes/SetAlert";
import SetMqttComponent from "../DeviceTypes/SetMqtt";

export default {
  props: {
    changedPath: String,
    choosenDeviceType: Object,
    path: String,
  },
  components: {
    "create-devType": CreateDeviceTypeComponent,
    "edit-devType": EditDeviceTypeComponent,
    "info-devType": DeviceTypeInfoComponent,
    "manage-user": ManageUserInDeviceTypeComponent,
    managealert: ManageAlertComponent,
    setalert: SetAlertComponent,
    setMqtt: SetMqttComponent,
  },

  data: () => ({
    deviceTypeAlert: null,
    deviceTypeMqtt: null,
  }),
  methods: {
    updateMqtt(mqtt) {
      this.deviceTypeMqtt = mqtt;
      this.$emit("updateMqtt", mqtt);
    },
    createMqtt() {
      this.deviceTypeMqtt = {};
      this.$emit("createMqtt");
    },

    updateAlert(alert) {
      this.deviceTypeAlert = alert;
      this.$emit("updateAlert", alert);
    },
    createAlert() {
      this.deviceTypeAlert = {};
      this.$emit("createAlert");
    },
    createDeviceType: function () {
      this.$emit("createDeviceType");
    },
    manageDataAndAlert: function () {
      this.$emit("manageDataAndAlert");
    },
    editDeviceType: function () {
      this.$emit("edit");
    },
    editUserInDeviceType: function () {
      this.$emit("user");
    },
    back: function () {
      this.$emit("back");
      window.scrollTo(0, 0);
    },
    backinfo: function () {
      this.$emit("backinfo");
      window.scrollTo(0, 0);
    },
    backManage: function () {
      this.$emit("backManage");
      window.scrollTo(0, 0);
    },
    error: function (value) {
      this.$emit("error", value);
    },
    saved: function (value) {
      this.$emit("saved", value);
    },
    alertSaved: function (value) {
      this.$emit("alertSaved", value);
    },
    mqttSaved: function (value) {
      this.$emit("mqttSaved", value);
    },
    clickmarker: function (value) {
      this.$emit("clickmarker", value);
    },
  },
};
</script>